import { render, staticRenderFns } from "./VerifyAuthentication.vue?vue&type=template&id=38ac4831&scoped=true"
import script from "./VerifyAuthentication.vue?vue&type=script&lang=js"
export * from "./VerifyAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac4831",
  null
  
)

export default component.exports